import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { Typography } from "@insite/mobius/index";
import LazyImage, { LazyImageStyle } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import NewYoutubeIcon from "@tsesco/Icons/NewYoutubeIcon";
import PlayButtonIcon from "@tsesco/Icons/PlayButtonIcon";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface VideoItem {
    title: string;
    videoId: string;
}

const enum fields {
    websiteurl = "websiteurl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.websiteurl]: string;
    };
}

type Props = WidgetProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    mobileGridView?: InjectableCss;
    container?: InjectableCss;
    twrapper?: InjectableCss;
    parent?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPrev?: ButtonPresentationProps;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    DesktopView?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNext?: ButtonPresentationProps;
    nextIcon?: IconPresentationProps;
    button?: LinkPresentationProps;
    buttonPREV?: ButtonPresentationProps;
    buttonNEXT?: InjectableCss;
    parentContainer?: InjectableCss;
    wrapperStyles?: InjectableCss;
    Box?: InjectableCss;
    titleButtonWarrper?: InjectableCss;
    iconWrapper?: InjectableCss;
    videoWrapper?: InjectableCss;
    videoModal?: ModalPresentationProps;
}

export const imgstyle: Imgstyle = {
    videoWrapper: {
        css: css`
            width: 100%;
        `,
    },
    titleButtonWarrper: {
        css: css`
            display: flex;
            justify-content: space-around;
            width: 100%;
            transition: transform 0.3s ease 0s;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        z-index: 2 !important;
                    `,
                    css``,
                ])};
            ${StyledButton} {
                display: flex;
                align-items: end !important;
            }
        `,
    },
    mobileGridView: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
        `,
    },
    iconWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            margin: 0;
            position: absolute;
            top: 45%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            width: 94%;
            outline: none;
            &:focus {
                outline: none;
            }
            > ${TypographyStyle} {
                display: flex;
            }
        `,
    },
    DesktopView: {
        css: css`
            opacity: 1;
            position: relative;
            margin: 0 auto;
            max-width: 1440px;
        `,
    },
    buttonPREV: {
        css: css`
            padding: 0;
            border: none;
            height: 40px;
            width: 40px;
            border-radius: 50%;
        `,
    },
    buttonNEXT: {
        css: css`
            padding: 0;
            height: 40px;
            width: 40px;
            border-radius: 50%;
        `,
    },
    prevArrowWrapper: {
        css: css`
            height: 10px;
            position: absolute;
            z-index: 1;
            top: 45%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            left: 0px;
            background: none;
            ${ButtonWrapper} {
                background: black;
                outline: black;
                border: black;
                &:focus {
                    outline-style: black;
                    outline-color: black;
                    outline-offset: 0px !important;
                }
                &:hover {
                    background: black;
                }
                &:active {
                    border: black;
                }
                &:disabled {
                    background: black;
                }
            }
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 45%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            right: 0px;
            ${ButtonWrapper} {
                background: black;
                outline: black;
                border: black;
                &:focus {
                    outline-style: black;
                    outline-color: black;
                    outline-offset: 0px;
                }
                &:hover {
                    background: black;
                }
                &:active {
                    border: black;
                }
            }
        `,
    },
    twrapper: {
        css: css`
            color: ${getColor("secondary")};
            font-size: 17px;
            width: 80%;
            text-transform: capitalize;
            font-family: "Roboto-Bold";
            align-items: left;
            // padding-left: 5px;
            &:hover {
                text-decoration: underline;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        width: 94%;
                    `,

                    css`
                        font-size: 16px;
                        width: 94%;
                    `,
                    css`
                        font-size: 19px;
                        width: 95%;
                    `,
                    css`
                        font-size: 17px;
                        width: 21rem;
                    `,
                    null,
                ])}
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            flex: 0 0 auto;
            outline: none;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 50%;
                        padding: 0px !important;
                        margin: 0px !important;
                    `,
                    css`
                        width: 50%;
                        padding: 0px !important;
                        margin: 0px !important;
                    `,
                    css`
                        width: 33.33%;
                        padding: 0px !important;
                        margin: 0px !important;
                    `,
                    css`
                        width: 33.33%;
                        padding: 0px !important;
                        margin: 0px !important;
                    `,
                ])};
        `,
    },
    parent: {
        css: css`
            display: flex;
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
            height: 100%;
        `,
    },
    wrapperStyles: {
        css: css`
            position: relative;
            max-width: 100%;
            height: 100%;
            margin-left: auto;
            margin-right: auto;
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            position: relative;
            justify-content: center;
            align-items: center;
            width: 100%;

            ${LazyImageStyle} {
                display: flex !important;
            }
            ${StyledButton} {
                outline: none;
                padding: 0px !important;
                margin: 0px !important;
            }
            iframe {
                width: 100%;
                height: auto;
            }
        `,
    },
    main: {
        css: css`
            position: relative;
        `,
    },
    videoModal: {
        sizeVariant: "large",
        cssOverrides: {
            scrim: css``,
            modalBody: css`
                max-width: 100% !important;
                height: 100% !important;
                background: black;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 55% !important;
                                margin: 10px;
                            `,
                        ],
                        "max",
                    )}
            `,
            modalTitle: css`
                background: black;
                border-bottom: none;
                padding: 0px;
                button {
                    padding: 5px !important;
                    background: black;
                    border: none;
                    span {
                        color: white !important;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding: 0px;
                            `,
                        ],
                        "max",
                    )}
            `,
            modalContent: css`
                background: black;
                padding: 0px;
                overflow-y: hidden;
                height: 100%;
                > iframe {
                    height: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                // padding: 5px;
                                > iframe {
                                    height: 99%;
                                }
                            `,
                        ],
                        "max",
                    )}
            `,
            modalContainer: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-top: 85px;
                                align-items: flex-start;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
    },
};

const styles = imgstyle;

export const SEVideoCarousel: FC<Props> = ({ theme, shellContext, fields }) => {
    const afterCarousel = createRef<HTMLSpanElement>();
    const [videos, setVideos] = useState<VideoItem[]>([]);

    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [showVideoIndex, setShowVideoIndex] = useState(-1);

    const decodeHTMLEntities = (html: string) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.innerText;
    };

    useEffect(() => {
        fetchYouTubeVideos();
    }, []);

    const fetchYouTubeVideos = () => {
        const websiteName = fields.websiteurl;

        const apiUrl = websiteName;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                const videos = data.items.map((item: any) => ({
                    title: decodeHTMLEntities(item.snippet.title),
                    videoId: item.id.videoId,
                }));
                setVideos(videos);
            })
            .catch(error => console.error("Error fetching videos:", error));
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const maxNumberOfSlideShow = 3;

    const getSlidesToScroll = useCallback(() => {
        if (typeof window === "undefined") {
            return maxNumberOfSlideShow;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else {
            localSlidesToScroll = 3;
        }
        return Math.min(localSlidesToScroll, maxNumberOfSlideShow);
    }, [maxNumberOfSlideShow]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();

        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [videos.length, windowResizeTime]);
    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    React.useEffect(() => {
        onWindowResize();
    }, []);
    useEffect(() => {
        if (!embla || !videos || videos.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            draggable: isTouchDevice(),
            loop: videos.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, videos]);

    if (!videos || videos.length === 0) {
        return null;
    }

    return (
        <>
            <StyledWrapper {...styles.DesktopView}>
                <StyledWrapper {...styles.main}>
                    <StyledWrapper {...styles.Box}>
                        <StyledWrapper>
                            <StyledWrapper>
                                {videos.length > 1 && (
                                    <StyledWrapper
                                        {...styles.prevArrowWrapper}
                                        style={{
                                            display: `${slidesToScroll >= videos.length ? "none" : "block"}`,
                                        }}
                                    >
                                        <Button
                                            {...styles.buttonPREV}
                                            onClick={() => {
                                                embla && embla.scrollPrev();
                                            }}
                                            disabled={!canScrollPrev}
                                        >
                                            <ButtonIcon src={ChevronLeft} />
                                        </Button>
                                    </StyledWrapper>
                                )}
                                <StyledWrapper
                                    {...styles.nextArrowWrapper}
                                    style={{
                                        display: `${slidesToScroll >= videos.length ? "none" : "block"}`,
                                    }}
                                >
                                    <Button
                                        {...styles.buttonNEXT}
                                        onClick={() => {
                                            embla && embla.scrollNext();
                                        }}
                                        disabled={!canScrollNext}
                                    >
                                        <ButtonIcon src={ChevronRight} />
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.wrapperStyles}>
                        <StyledWrapper {...styles.container} ref={emblaRef}>
                            <StyledWrapper {...styles.parent}>
                                {videos.map((video, index) => {
                                    const videoThumbnailUrl = `https://i.ytimg.com/vi/${video.videoId}/mqdefault.jpg`;
                                    return (
                                        <>
                                            <StyledWrapper {...styles.parentContainer} key={index}>
                                                <StyledWrapper {...styles.mobileGridView}>
                                                    <StyledWrapper {...styles.ImageAndSpecialwrapper} ref={emblaRef}>
                                                        {showVideoIndex === index ? (
                                                            <StyledWrapper {...styles.videoWrapper}>
                                                                <Modal
                                                                    isOpen={modalIsOpen}
                                                                    handleClose={modalCloseHandler}
                                                                    {...styles.videoModal}
                                                                >
                                                                    <iframe
                                                                        width="100%"
                                                                        src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1`}
                                                                        frameBorder="0"
                                                                        className="videoWrapper"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                    ></iframe>
                                                                </Modal>
                                                            </StyledWrapper>
                                                        ) : (
                                                            <Link
                                                                onClick={() => {
                                                                    setShowVideoIndex(index);
                                                                    setModalIsOpen(true);
                                                                }}
                                                                css={css`
                                                                    span {
                                                                        display: flex;
                                                                    }
                                                                `}
                                                            ></Link>
                                                        )}
                                                    </StyledWrapper>
                                                    <StyledWrapper
                                                        css={css`
                                                            display: flex;
                                                            flex-direction: column;
                                                            &:hover .icon .mainColor {
                                                                fill: rgba(255, 0, 0, 1) !important;
                                                            }
                                                            &:hover .title {
                                                                text-decoration: underline;
                                                            }
                                                        `}
                                                    >
                                                        <StyledWrapper
                                                            {...styles.titleButtonWarrper}
                                                            css={css`
                                                                background: url(${videoThumbnailUrl});
                                                                background-size: 100%;
                                                                background-repeat: round;
                                                                display: flex;
                                                                align-items: center;
                                                                justify-content: space-around;
                                                                margin-bottom: 15px;
                                                                min-height: 38vh;
                                                                width: 100%;
                                                                transition: transform 0.3s ease 0s;

                                                                &:hover {
                                                                    /* transform: scale(1.1); */
                                                                }
                                                                @media (min-width: 2560px) {
                                                                    background-repeat: no-repeat !important;
                                                                }
                                                                @media (min-width: 1980px) {
                                                                    background-repeat: no-repeat !important;
                                                                }

                                                                ${({ theme }: { theme: BaseTheme }) =>
                                                                    breakpointMediaQueries(theme, [
                                                                        css`
                                                                            min-height: 29vh;
                                                                        `,
                                                                        css`
                                                                            min-height: 29vh;
                                                                        `,
                                                                        css`
                                                                            min-height: 22vh;
                                                                        `,
                                                                        css`
                                                                            min-height: 14vh;
                                                                        `,
                                                                        null,
                                                                    ])};
                                                            `}
                                                        >
                                                            {" "}
                                                        </StyledWrapper>
                                                        <Link
                                                            className="title"
                                                            css={css`
                                                                > span {
                                                                    padding-left: 5px;
                                                                }
                                                                &:focus {
                                                                    outline: none;
                                                                }
                                                            `}
                                                            onClick={() => {
                                                                setShowVideoIndex(index);
                                                                setModalIsOpen(true);
                                                            }}
                                                        >
                                                            {video.title && (
                                                                <Typography {...styles.twrapper}>
                                                                    {video.title}
                                                                </Typography>
                                                            )}
                                                        </Link>
                                                        <Link
                                                            onClick={() => {
                                                                setShowVideoIndex(index);
                                                                setModalIsOpen(true);
                                                            }}
                                                            {...styles.iconWrapper}
                                                            className="icon"
                                                        >
                                                            <NewYoutubeIcon />
                                                        </Link>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </>
                                    );
                                })}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SEVideoCarousel)),
    definition: {
        group: "Basic",
        displayName: "SE Video Carousel",
        fieldDefinitions: [
            {
                name: fields.websiteurl,
                displayName: "Youtube URL",
                editorTemplate: "TextField",
                defaultValue:
                    "https://sesco-spire-standardelectric.commerce.insitesandbox.com/userfiles/ad/youtube/youtubeapikey.txt",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
